import { LoginPage } from '$pages/auth/login/login';
import { ItemProvider } from '$providers/item';
import { LoginProvider } from '$providers/login';
import { SettingsProvider } from '$providers/settings';
import { ViewProvider } from '$providers/view';
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  public keys: '';
  public items: Array<any>;
  public itemsToolbar: Array<any>;
  public userName: string;
  public tituloHome: string;
  public colors: Array<any>;

  public settings: any = {};

  constructor(private navCtrl: NavController, private sanitizer: DomSanitizer, _login: LoginProvider,
    private _view: ViewProvider, private _settings: SettingsProvider, private _item: ItemProvider) {

    this.tituloHome = "";
    this.colors = ['white'];

    this.userName = _login.get().name;

    this.loadHome();
  }

  private loadHome() {
    this._settings.loadSettingsFromServer().subscribe(
      (settings) => {
        this.settings = settings;
        this.items = this._item.getItems(this.settings)
          .filter((i) => !i.hideHome);
        this.itemsToolbar = this._item.getItems(this.settings)
          .filter((i) => i.showToolbar);

        this.tituloHome = this.settings.tituloHome;

        if (this.settings.cores)
          this.colors = this.settings.cores;

        // this.loadGroups();
      },
      () => {
        // this.loadGroups();
      }
    );
  }

  public getWelcomeMessage() {
    let d = new Date();

    let msg = '';
    if (d.getHours() >= 2 && d.getHours() < 12) {
      msg += 'Bom dia';
    } else if (d.getHours() >= 12 && d.getHours() < 18) {
      msg += 'Boa tarde';
    } else {
      msg += 'Boa noite';
    }

    if (this.userName) {
      msg += ', ' + this.userName.substring(0, this.userName.indexOf(' '));
    }
    msg += '!';

    return msg;
  }

  public getImage(image): any {
    return this.sanitizer.bypassSecurityTrustUrl("data:Image/*;base64," + image);
  }

  sair() {
    this._view.showConfirm("Deseja sair da aplicação?", () => {
      this.navCtrl.setRoot(LoginPage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts